const BaseComponent = require('base/infoline');

module.exports = class a extends BaseComponent { };
